import React from "react";
import { MapPin, ArrowRight, CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const events = [{
  id: 1,
  month: "OCT",
  day: "12",
  title: "The Solstice Pulse: Deep Movement",
  location: "Tulum, Mexico",
  link: "/GlobalGatheringsPage"
}, {
  id: 2,
  month: "NOV",
  day: "05",
  title: "Obsidian Flow Ritual",
  location: "Berlin, Germany",
  link: "/GlobalGatheringsPage"
}, {
  id: 3,
  month: "DEC",
  day: "10",
  title: "Midnight Mantra & Bass",
  location: "Ibiza, Spain",
  link: "/GlobalGatheringsPage"
}, {
  id: 4,
  month: "JAN",
  day: "22",
  title: "Primal Awakening Ceremony",
  location: "Bali, Indonesia",
  link: "/GlobalGatheringsPage"
}];
export default function UpcomingGatherings() {
  return <section data-section-id="127878" id="gathering-hub" className="py-16 md:py-24 bg-background text-foreground dark">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary/10 text-primary text-sm font-default mb-4 border border-[#a855f7] tracking-widest">
              <CalendarDays className="size-4" />
              <span className="uppercase">The Circuit</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-default tracking-tighter text-foreground mb-4 uppercase">
              Global Gatherings
            </h2>
            <p className="text-lg text-muted-foreground font-default tracking-normal">
              Step into the sonic sanctuary. Immerse yourself in nights of deep movement, 
              sacred ritual, and elevated connection across the globe.
            </p>
          </div>
          <div className="shrink-0">
            <Button variant="outline" className="border-[#a855f7] hover:bg-primary hover:text-primary-foreground transition-all duration-500" asChild>
              <Link to="#">
                Explore the Circuit
                <ArrowRight className="size-4 ml-2" />
              </Link>
            </Button>
          </div>
        </div>

        <div className="flex flex-col gap-0 border-t border-[#a855f7]">
          {events.map((event, i) => <div key={event.id} data-index={i} className="group flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 p-6 border-b border-[#a855f7] bg-transparent hover:bg-primary/5 transition-all duration-500">
              {}
              <div className="flex flex-col items-center justify-center w-16 h-16 bg-primary/5 text-primary shrink-0 border border-[#a855f7]/50 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-500">
                <span className="text-xs font-default font-bold tracking-widest uppercase">
                  {event.month}
                </span>
                <span className="text-xl font-default font-bold leading-none mt-1">
                  {event.day}
                </span>
              </div>

              {}
              <div className="flex-1 space-y-1">
                <h3 className="text-xl font-default font-semibold text-foreground group-hover:text-primary transition-colors duration-300 tracking-tight uppercase">
                  {event.title}
                </h3>
                <div className="flex items-center text-sm text-muted-foreground gap-1.5 font-default tracking-wide italic">
                  <MapPin className="size-4 shrink-0 text-secondary" />
                  <span className="truncate">{event.location}</span>
                </div>
              </div>

              {}
              <div className="w-full sm:w-auto mt-2 sm:mt-0 shrink-0">
                <Button variant="secondary" className="w-full sm:w-auto bg-muted hover:bg-primary hover:text-primary-foreground transition-all duration-500 font-default uppercase tracking-widest text-xs" asChild>
                  <Link to={event.link}>
                    Secure Space
                    <ArrowRight className="size-4 ml-2 opacity-70 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}